import {
  FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE, FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE_SUCCEEDED, FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE_FAILED,
  FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE, FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE_SUCCEEDED, FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE_FAILED,
  FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE, FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE_SUCCEEDED, FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE_FAILED,
} from 'constants/actionTypes';

import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import buildUrl from 'build-url';

const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;

const LANDING_PAGE_REPORTS_BASE_URL = `${apiUrl}/api/1.0/landing_page/reports`;

/**
 * Fetch Landing Page Reports
*/
export const fetchPagesReportsForLandingPage = createAction(FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE, (request, page, limit) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
});

const fetchingPagesReportsForLandingPageSucceeded = createAction(FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingPagesReportsForLandingPageFailed = createAction(FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingPagesReportsForLandingPageSaga(action) {
  const { request, page, limit } = action.payload;

  let url = buildUrl(LANDING_PAGE_REPORTS_BASE_URL, {
    path: `/pages?page=${page}&limit=${limit}`
  });

  const fetchingPagesReportsForLandingPageAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingPagesReportsForLandingPageAPI);
    if (response) {
      yield put(fetchingPagesReportsForLandingPageSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingPagesReportsForLandingPageFailed(request.storyboard, error));
  }
}

/**
 * Fetch Landing Page Charts Report
*/
export const fetchPagesChartReportsForLandingPage = createAction(FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE, (request, page, limit) => {
  return {
    request: request,
    page: page,
    limit: limit
  }
});

const fetchingPagesChartReportsForLandingPageSucceeded = createAction(FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE_SUCCEEDED, (id, response) => {
  return {
    id: id,
    response: response
  }
});

const fetchingPagesChartReportsForLandingPageFailed = createAction(FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE_FAILED, (id, error) => {
  return {
    id: id,
    error: error
  }
})

function* fetchingPagesChartsForLandingPageSaga(action) {
  const { request, page, limit } = action.payload;

  let url = buildUrl(LANDING_PAGE_REPORTS_BASE_URL, {
    path: `/pages?page=${page}&limit=${limit}`
  });

  const fetchingPagesReportsForLandingPageAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    const response = yield call(fetchingPagesReportsForLandingPageAPI);
    if (response) {
      yield put(fetchingPagesChartReportsForLandingPageSucceeded(request.storyboard, response));
    }
  } catch (error) {
    yield put(fetchingPagesChartReportsForLandingPageFailed(request.storyboard, error));
  }
}


/**
 * Fetch Page Bar Analytics Chart For Landing Page
*/
export const fetchAnalyticsChartForLandingPage = createAction(FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE, (request, type) => {
  return {
    request: request,
    type: type
  }
});

const fetchAnalyticsChartForLandingPageSucceeded = createAction(FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE_SUCCEEDED, (id, response, type) => {
  return {
    id: id,
    response: response,
    type: type
  }
});

const fetchAnalyticsChartForLandingPageFailed = createAction(FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE_FAILED, (id, error, type) => {
  return {
    id: id,
    error: error,
    type: type
  }
})

function* fetchAnalyticsReportsForLandingPageSaga(action) {
  const { request, type } = action.payload;

  let url = buildUrl(LANDING_PAGE_REPORTS_BASE_URL, {
    path: `/analytics`
  });

  const fetchAnalyticsChartForLandingPageAPI = () => {
    return axios.post(url, request).then(response => response.data);
  }

  try {
    var response = yield call(fetchAnalyticsChartForLandingPageAPI);

    if (response) {
      yield put(fetchAnalyticsChartForLandingPageSucceeded(request.storyboard, response, type));
    }
  } catch (error) {
    yield put(fetchAnalyticsChartForLandingPageFailed(request.storyboard, error, type));
  }
}

export default function* landingPageReportsSaga() {
  yield takeEvery(FETCHING_PAGES_REPORTS_FOR_LANDING_PAGE, fetchingPagesReportsForLandingPageSaga);
  yield takeEvery(FETCHING_PAGES_CHARTS_REPORTS_FOR_LANDING_PAGE, fetchingPagesChartsForLandingPageSaga);
  yield takeEvery(FETCHING_ANALYTICS_CHART_FOR_LANDING_PAGE, fetchAnalyticsReportsForLandingPageSaga);
}